import { Auth } from 'aws-amplify';

import {
	AUTHENTICATION_INITIATED,
	AUTHENTICATION_FAILED,
	AUTHENTICATION_SUCCEEDED
} from '../actions/AuthenticationActions';

//Auth.currentAuthenticatedUser()
//.then(user => console.log(user))
//.catch(err => console.log(err));

const initialState = {
  authenticated: true,
  authenticating: false,
  failure: false
};

export const AuthenticationReducer = (state = initialState, action) => {
  switch(action.type) {
    case AUTHENTICATION_INITIATED:
      return {
        ...state,
				authenticating: true,
				failure: false
      };
		case AUTHENTICATION_FAILED:
      return {
        ...state,
				authenticated: false,
				authenticating: false,
				failure: true
      };
		case AUTHENTICATION_SUCCEEDED:
      return {
        ...state,
				authenticated: true,
				authenticating: false,
				failure: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./state/reducers/AuthenticationReducer.js